import type { FC } from 'react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from 'src/components/buttons-and-actions/button';
import { Container } from 'src/components/layout/container';
import { ExternalLink } from 'src/components/navigation/link';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import { useTrackingConfig } from 'src/hooks/use-tracking-config';
import { readTrackingCookie } from 'src/utils/tracking-cookie';

export const CookieBanner: FC = () => {
  const { updateTrackingConfig } = useTrackingConfig();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  const [configured, setConfigured] = useState(() => {
    if (monolithUser && 'allow' in monolithUser.trackingSettings) {
      return 'allow' in monolithUser.trackingSettings;
    } else {
      return Boolean(readTrackingCookie());
    }
  });

  const onChange = (allow: boolean) => {
    updateTrackingConfig(allow);
    setConfigured(true);
    toast.success('Successfully saved cookie preference!');
  };

  if (configured) return null;

  return (
    <div className="bg-white p-xl">
      <Container>
        <div className="grid items-center gap-xl">
          <p>
            <strong>Take part in PRISMA usability research</strong>
          </p>

          <p>
            We would like your help in improving your experience with PRISMA. If
            you agree to participate, we will automatically gather usage data
            via browser cookies that we aggregate and analyse. We will also
            occasionally request feedback from you via survey. In no case is
            personally-identifiable data collected.
          </p>

          <div className="grid grid-flow-col items-center justify-end gap-md">
            <ExternalLink
              href="https://www.prisma-capacity.eu/privacy"
              target="_blank"
            >
              More Information
            </ExternalLink>
            <Button mode="secondary" onClick={() => onChange(false)}>
              Decline
            </Button>
            <Button onClick={() => onChange(true)}>Accept & Close</Button>
          </div>
        </div>
      </Container>
    </div>
  );
};
